module.exports = __webpack_public_path__ + "7243af223bd9e51ad16b0d4b09534cbf.png";